import _ from "lodash";
import { Permission } from "../../permissions";
import { RoleTransaction } from "../store";

export interface UpdateRoleInput {
  name: string;
  permissions: Permission[];
}

export type UpdateRoleCommand = (
  roleUuid: string,
  updated: UpdateRoleInput,
) => Promise<void>;

interface CommandProps {
  roleTransaction: RoleTransaction;
}

export const UpdateRoleCommand =
  ({ roleTransaction }: CommandProps): UpdateRoleCommand =>
  (roleUuid, updated) =>
    roleTransaction(async (retrieve, persist) => {
      const role = await retrieve(roleUuid);
      const filteredPermissions = _.uniq(updated.permissions);

      await persist({
        ...role,
        name: updated.name,
        permissions: filteredPermissions,
        updatedAt: new Date(),
      });
    });
